<script setup>
import { trans as $t } from 'laravel-vue-i18n';
</script>

<script>
export default {
    name: 'BenefitCards',
    data() {
        return {
            benefits: [{
                title: 'Door to door',
                description: 'Felvesszük Önt a megadott címen, és közvetlenül a repülőtérre visszük, vagy fordítva.',
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" role="img"><g stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M12 52V14a4 4 0 0 1 4-4h18v42M34 14h12a4 4 0 0 1 4 4v34M10 52h44"/><circle cx="28" cy="32" r="1.8" fill="currentColor" stroke="none"/><path d="M46 33h-8M42 29l4 4-4 4M18 52v-9a6 6 0 0 1 12 0v9"/></g></svg>',
            }, {
                title: 'Fix díj',
                description: 'Az ár előre ismert, és nem változik a forgalom vagy az útvonal függvényében.',
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" role="img"><g stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M14 18h36a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H14a4 4 0 0 1-4-4V22a4 4 0 0 1 4-4zM18 28h10M18 36h7M38 27c-4 0-7 3-7 7s3 7 7 7M30 32h10M30 36h10M45 24v20M41 28l4-4 4 4M41 40l4 4 4-4"/></g></svg>',
            }, {
                title: 'Ingyenes gyerekülés',
                description: 'Díjmentesen biztosítunk gyerekülést a gyermekkel utazó utasaink számára.',
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" role="img"><g stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M23 20a8 8 0 0 1 16 0v5H23v-5zM18 28h28l-4 22H22l-4-22zM25 36h14M26 44h12M15 19l3 3 6-7M43 14h8M47 10v8"/></g></svg>',
            }, {
                title: 'Egy nagy és egy kis poggyász',
                description: 'Személyenként egy nagy bőröndöt és egy kézipoggyászt hozhat magával extra költségek nélkül.',
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" role="img"><g stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M28 18h16a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4H28a4 4 0 0 1-4-4V22a4 4 0 0 1 4-4zM31 18v-5h10v5M31 52v4M41 52v4M32 27v16M40 27v16M12 30h10a3 3 0 0 1 3 3v15a3 3 0 0 1-3 3H12a3 3 0 0 1-3-3V33a3 3 0 0 1 3-3zM14 30v-4h6v4M14 51v3M20 51v3"/></g></svg>',
            }, {
                title: 'Ingyenes Wi-Fi',
                description: 'Élvezze az ingyenes vezeték nélküli internetet a transzfer teljes időtartama alatt.',
                icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" role="img"><g stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M14 26a29 29 0 0 1 36 0M21 34a18 18 0 0 1 22 0M28 42a7 7 0 0 1 8 0"/><circle cx="32" cy="49" r="2.5" fill="currentColor" stroke="none"/><path d="M44 12h8M48 8v8"/></g></svg>',
            }]
        };
    },
}
</script>
<style lang="css">
.icon-container svg {
    width: 56px;
    height: 56px;
}
</style>
<template>

    <div class="row justify-content-center text-center">
        <div v-for="benefit in benefits" :key="benefit.title" class="col-6 col-md mb-3">
            <div class="card h-100 bg-secondary text-white" style="--bs-bg-opacity: .9">
                <div class="card-body d-flex flex-column align-items-center icon-container">
                    <div v-html="benefit.icon"></div>
                    <div class="fw-semibold">{{ $t(benefit.title) }}</div>
                </div>
            </div>
        </div>
    </div>

</template>
